import React from 'react';
import { connect } from 'react-redux';

import * as Types from 'types';
import { selectEditionsPlaylist } from 'features/playlists/selectors';
import { PlaylistContainer } from 'playlists/PlaylistContainer';
import { PlaylistFilter } from 'playlists/components/PlaylistFilter';

type StateProps = {
  editionsPlaylist: Types.Playlist;
};

type DispatchProps = {};

type OwnProps = Types.Styleable;

type Props = StateProps & DispatchProps & OwnProps;

const VaultArtworksSelector: React.FC<Props> = (props) => {
  const [filter, setFilter] = React.useState('');

  return (
    <div className='artworks-selector'>
      <PlaylistFilter className='mb-1' onChange={(query) => setFilter(query)} />
      <PlaylistContainer
        items={props.editionsPlaylist.items}
        filterQuery={filter}
        droppable={false}
        playlistIsEditable={false}
        isEdit
        showFilter
        showAdd
      />
    </div>
  );
};

const mapStateToProps = (state: Types.RootState) => ({
  editionsPlaylist: selectEditionsPlaylist(state),
});

const mapDispatchToProps = {};

export const VaultArtworksSelectorContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(VaultArtworksSelector);
